import { useState } from 'react';

import DeleteConfirmationDialog from '../../components/DeleteConfirmationDialog';
import GreenButton from '../../components/GreenButton';
import UserDialog from './UserDialog';
import UserList from './UserList';

import { Button, Grid, Paper } from '@mui/material';

import { useUser } from './api/getUser';
import { useDeleteUser } from './api/deleteUser';
import UserPermissionManagementSection from './UserPermissionManagementSection';

const UserManagementPage = () => {
  const [selectedUserId, setSelectedUserId] = useState<null | number>(null);
  const { data: user } = useUser({
    userId: selectedUserId || -1,
  });
  const deleteUserMutation = useDeleteUser({});

  const [createUserDialogOpen, setCreateUserDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleUserClicked = (userId: number) => {
    setSelectedUserId(userId);
  };

  const handleCreateUserClicked = () => {
    setSelectedUserId(null);
    setCreateUserDialogOpen(!createUserDialogOpen);
  };

  const handleDeleteUserClicked = async () => {
    if (!selectedUserId) return;
    await deleteUserMutation.mutateAsync(selectedUserId);
  };

  const handleEditUserClicked = () => {
    setCreateUserDialogOpen(!createUserDialogOpen);
  };

  const handleDialogClosed = () => {
    setCreateUserDialogOpen(false);
  };

  return (
    <>
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        itemToDelete={`User ${selectedUserId !== null && user?.name}`}
        onSubmit={handleDeleteUserClicked}
        onClose={() => setDeleteDialogOpen(false)}
      />
      <Grid container spacing={2}>
        <Grid container xs={6} item spacing={2} direction='column'>
          <Grid container item spacing={1}>
            <UserDialog
              open={createUserDialogOpen}
              handleClose={handleDialogClosed}
              selectedUserId={selectedUserId}
            />
            <Grid item>
              <GreenButton name='New' onClick={handleCreateUserClicked} />
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color='primary'
                onClick={handleEditUserClicked}
                disabled={selectedUserId === null}
              >
                Edit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color='error'
                onClick={() => setDeleteDialogOpen(true)}
                disabled={selectedUserId === null}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
          <Grid container item>
            <Grid
              sx={{ overflow: 'auto', maxHeight: '80vh' }}
              item
              component={Paper}
              xs
            >
              <UserList
                handleUserClicked={handleUserClicked}
                selectedUser={selectedUserId}
              />
            </Grid>
          </Grid>
        </Grid>
        <UserPermissionManagementSection selectedUserId={selectedUserId} />
      </Grid>
    </>
  );
};

export default UserManagementPage;
